import useRequest from './useRequest';

interface VetApproveHistoryData {
  requestDate: string;
}

// eslint-disable-next-line no-shadow
export enum LoadStatusCode {
  Approved = '1',
  Pending = '2',
  Expired = '3',
  Reported = '4',
}

export interface Load {
  requestCode: string;
  /** شناسه سفارش
   * @example "RNPO-xxxxxx"
   * */
  reqIdentification: string;
  /** تخصیص دهنده */
  assignerName: string;
  /** کد تخصیص دهنده */
  assignerCode: string;
  /** منبع تامین */
  supplierName: string;
  /** کد منبع تامین */
  supplierCode: string;
  /** مقدار تخصیص شده */
  reqAmount: string;
  /** واحد بار */
  reqMeasure: string;
  /** تاریخ سفارش */
  reqDate: string;
  /** تاریخ تخصیص */
  assignDate: string;
  /** مقدار بار ورودی تایید شده */
  approveAmount: string;
  /** زمان تایید */
  approveDate: string;
  /** زمان ثبت سفارش */
  registerDate: string;
  /** زمان دریافت سفارش */
  receiveDate: string;
  /** کد وضعیت بار */
  StatusCode: LoadStatusCode;
  /** وضعیت بار */
  StatusText: string;
  /** تاریخ تحویل */
  deliveryDate: string;
}

function useVetApproveHistory(data: VetApproveHistoryData) {
  const { requestDate } = data;
  const [vetApproveHistory, result] = useRequest<Load[]>('VetApproveHistory', {
    params: `RequestDate=${requestDate}`,
  });

  return { refetch: vetApproveHistory, result };
}

export default useVetApproveHistory;
